import { AloMission } from '@/models/alo/AloMission'
import { FilterMission } from '@/models/filter/FilterMission'
import { IAd2cpConfig } from '@/models/iris/ad2cp/IAd2cpConfig'
import { IAisConfig } from '@/models/iris/ais/IAisConfig'
import { ICoriolisConfig } from '@/models/iris/coriolis/ICoriolisConfig'
import { IQuickControlConfig } from '@/models/iris/quickControlConfig/IQuickControlConfig'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { IMissionPlan } from '@/models/iris/missionPlan/IMissionPlan'
import { IMissionPlanConfig } from '@/models/iris/missionPlanConfig/IMissionPlanConfig'
import { ISendMailConfig } from '@/models/iris/sendMail/ISendMailConfig'
import { MissionUi } from '@/models/ui/MissionUi'

export interface IMissionState {
  status: string
  missions: Array<AloMission>
  //Tableau des id de gliders pour lesquels les missions ont été chargées
  missionsPassedLoaded: Array<number>
  missionsPassedLoading: boolean
  missionsOngoingLoading: boolean
  simulationRunning: boolean

  virtualMissionDic: { [index: number]: AloMission }
  virtualMissions: Array<number>

  //selectedMissions: Array<AloMission>
  //filterResultMissions: Array<AloMission>
  filterMission: FilterMission
  //liste des missions ouverte en detail
  detailMissions: Array<MissionUi>
  currentDetailMission: MissionUi
  sendMailLoading: boolean
  originalSendMailConfigs: { [index: number]: IrisConfigContainer<ISendMailConfig> }
  modifiedSendMailConfigs: { [index: number]: IrisConfigContainer<ISendMailConfig> }
  missionPlanStagingLoading: boolean
  originalIrisMissionPlan: { [index: number]: IMissionPlan }
  missionPlanIrisLoading: boolean
  originalMissionPlanConfigs: { [index: number]: IrisConfigContainer<IMissionPlanConfig> }
  modifiedMissionPlanConfigs: { [index: number]: IrisConfigContainer<IMissionPlanConfig> }
  missionPlanConfigLoading: boolean
  ad2cpLoading: boolean
  originalAd2cpConfigs: { [index: number]: IrisConfigContainer<IAd2cpConfig> }
  modifiedAd2cpConfigs: { [index: number]: IrisConfigContainer<IAd2cpConfig> }
  coriolisLoading: boolean
  originalCoriolisConfigs: { [index: number]: IrisConfigContainer<ICoriolisConfig> }
  modifiedCoriolisConfigs: { [index: number]: IrisConfigContainer<ICoriolisConfig> }
  aisLoading: boolean
  originalAisConfigs: { [index: number]: IrisConfigContainer<IAisConfig> }
  modifiedAisConfigs: { [index: number]: IrisConfigContainer<IAisConfig> }
  encryptionRevealLoading: boolean
  encryptionSaveLoading: boolean
  refreshPicture: boolean
  quickcontrolConfigLoading: boolean
  originalQuickControlConfigs: { [index: number]: IrisConfigContainer<IQuickControlConfig> }
  modifiedQuickControlConfigs: { [index: number]: IrisConfigContainer<IQuickControlConfig> }
}

const state: IMissionState = {
  status: '',
  missions: [],
  missionsPassedLoaded: [],
  missionsPassedLoading: false,
  missionsOngoingLoading: false,
  simulationRunning: false,
  virtualMissionDic: {},
  virtualMissions: [],

  filterMission: new FilterMission(),
  //selectedMissions: [],
  //filterResultMissions: [],
  //liste des missions ouverte en detail
  detailMissions: [],
  currentDetailMission: new MissionUi(),
  sendMailLoading: false,
  missionPlanStagingLoading: false,
  originalSendMailConfigs: {} as { [index: number]: IrisConfigContainer<ISendMailConfig> },
  modifiedSendMailConfigs: {} as { [index: number]: IrisConfigContainer<ISendMailConfig> },
  missionPlanIrisLoading: false,
  originalIrisMissionPlan: {} as { [index: number]: IMissionPlan },
  missionPlanConfigLoading: false,
  originalMissionPlanConfigs: {} as { [index: number]: IrisConfigContainer<IMissionPlanConfig> },
  modifiedMissionPlanConfigs: {} as { [index: number]: IrisConfigContainer<IMissionPlanConfig> },
  ad2cpLoading: false,
  originalAd2cpConfigs: {} as { [index: number]: IrisConfigContainer<IAd2cpConfig> },
  modifiedAd2cpConfigs: {} as { [index: number]: IrisConfigContainer<IAd2cpConfig> },
  coriolisLoading: false,
  originalCoriolisConfigs: {} as { [index: number]: IrisConfigContainer<ICoriolisConfig> },
  modifiedCoriolisConfigs: {} as { [index: number]: IrisConfigContainer<ICoriolisConfig> },
  aisLoading: false,
  originalAisConfigs: {} as { [index: number]: IrisConfigContainer<IAisConfig> },
  modifiedAisConfigs: {} as { [index: number]: IrisConfigContainer<IAisConfig> },
  encryptionRevealLoading: false,
  encryptionSaveLoading: false,
  refreshPicture: false,
  quickcontrolConfigLoading: false,
  originalQuickControlConfigs: {} as { [index: number]: IrisConfigContainer<IQuickControlConfig> },
  modifiedQuickControlConfigs: {} as { [index: number]: IrisConfigContainer<IQuickControlConfig> },
}

export default state
